var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup48095513(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 56,
    viewBox: "0 0 31 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27,
    fill: "#E6F4FF",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7921 27.1265L17.0242 40.423C17.0555 40.7202 17.2272 40.9846 17.486 41.134L18.7375 41.8565C19.0374 42.0296 19.4068 42.0296 19.7067 41.8565L21.6615 40.7279C21.9504 40.5611 22.1284 40.2528 22.1284 39.9192V29.1609L15.7921 27.1265Z",
    fill: "url(#paint0_linear_715_338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0839 30.2766L18.9602 32.2269L22.1283 35.0513V29.1609L15.7921 27.1265L16.0839 30.2766Z",
    fill: "url(#paint1_linear_715_338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9204 17.3762L20.2485 14.0075C20.2162 13.9871 20.1836 13.9671 20.1504 13.948C19.1258 13.3564 17.8617 13.4348 16.591 14.1684C15.3411 14.8901 14.1787 16.1933 13.3179 17.838C12.468 19.4618 12 21.2477 12 22.8667C12 24.7871 12.6769 26.2793 13.857 26.9606C13.8645 26.9649 13.8722 26.9685 13.8797 26.9727L13.8796 26.9729L19.4781 30.296L25.9204 17.3762Z",
    fill: "url(#paint2_linear_715_338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3214 16.9855C23.6921 17.0077 23.0275 17.2119 22.361 17.5966C21.1111 18.3182 19.9487 19.6215 19.0879 21.2663C18.238 22.8901 17.77 24.6759 17.77 26.2949C17.77 27.3857 17.9887 28.3381 18.3936 29.0824L18.3934 29.0828L26.5892 40.4451L37.4019 18.024L24.3214 16.9855Z",
    fill: "url(#paint3_linear_715_338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6958 18.5511C36.9047 17.5169 34.6948 17.6539 32.4734 18.9364C30.2885 20.1979 28.2564 22.4761 26.7515 25.3514C25.2658 28.1901 24.4476 31.3121 24.4476 34.1423C24.4476 37.4994 25.6309 40.108 27.6939 41.2992C28.4887 41.7581 29.3657 41.9863 30.2897 41.9863C31.4482 41.9863 32.6806 41.6273 33.9163 40.9139C36.1013 39.6524 38.1334 37.3742 39.6382 34.4989C41.1239 31.6602 41.9421 28.5382 41.9421 25.7079C41.9421 22.3508 40.7589 19.7422 38.6958 18.5511Z",
    fill: "url(#paint4_linear_715_338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3899 33.6573L25.8007 30.4303L30.1161 23.3733L34.9999 26.193L31.3899 33.6573Z",
    fill: "url(#paint5_linear_715_338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 26.193C34.4122 25.8536 33.6871 25.8985 32.9581 26.3194C32.2412 26.7333 31.5744 27.4809 31.0806 28.4244C30.5931 29.3558 30.3246 30.3802 30.3246 31.3089C30.3246 32.4105 30.7129 33.2665 31.3898 33.6573C31.6506 33.8079 31.9384 33.8828 32.2416 33.8828C32.6217 33.8828 33.0261 33.765 33.4316 33.5309C34.1485 33.1169 34.8153 32.3694 35.3092 31.4259C35.7967 30.4945 36.0652 29.4701 36.0652 28.5413C36.0651 27.4397 35.6769 26.5838 34.9999 26.193Z",
    fill: "#E9E5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9384 43.4449C28.9026 43.4449 27.9195 43.1891 27.0286 42.6747C24.716 41.3395 23.3897 38.4155 23.3897 34.6523C23.3897 31.4798 24.3069 27.9803 25.9722 24.7983C27.6591 21.5753 29.9369 19.0215 32.3861 17.6074C34.8762 16.1698 37.3533 16.0163 39.3611 17.1755C41.6737 18.5107 43 21.4347 43 25.1979C43 28.3704 42.0828 31.8699 40.4175 35.052C38.7306 38.275 36.4528 40.8288 34.0036 42.2429C32.6183 43.0425 31.2369 43.4449 29.9384 43.4449ZM36.4403 19.6402C35.5634 19.6402 34.6831 20.0164 34.0036 20.4088C30.0037 22.7181 26.6245 29.2408 26.6245 34.6523C26.6245 37.1907 27.3802 39.1425 28.646 39.8733C29.8826 40.5872 31.3625 40.0326 32.3862 39.4415C36.386 37.1321 39.7653 30.6094 39.7653 25.1979C39.7653 22.6595 39.0096 20.7077 37.7437 19.9769C37.328 19.7368 36.8845 19.6402 36.4403 19.6402Z",
    fill: "url(#paint6_linear_715_338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5298 25.5527C41.2679 22.923 39.9653 20.1422 37.4663 19.8404C37.5598 19.8797 37.6525 19.9243 37.7437 19.9769C39.0095 20.7077 39.7653 22.6595 39.7653 25.1979C39.7653 30.6094 36.3861 37.1322 32.3862 39.4415C31.3624 40.0326 29.8826 40.5873 28.646 39.8734C28.6186 39.8576 28.5917 39.8404 28.5648 39.8233C29.7908 40.7203 33.3053 41.2179 36.6648 38.0817C40.8351 34.1885 41.7924 28.1882 41.5298 25.5527Z",
    fill: "url(#paint7_linear_715_338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0415 22.5357L13.7448 21.2097C13.4533 21.0414 13.217 21.2201 13.217 21.6088C13.217 21.9975 13.4533 22.449 13.7448 22.6174L16.0415 23.9433C16.333 24.1117 16.5693 23.933 16.5693 23.5443C16.5694 23.1556 16.333 22.704 16.0415 22.5357Z",
    fill: "#2B0B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0415 24.6512L13.7448 23.3252C13.4533 23.1569 13.217 23.3355 13.217 23.7243C13.217 24.113 13.4533 24.5645 13.7448 24.7328L16.0415 26.0588C16.333 26.2271 16.5693 26.0485 16.5693 25.6598C16.5694 25.271 16.333 24.8194 16.0415 24.6512Z",
    fill: "#2B0B0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_338",
    x1: 18.4263,
    y1: 34.5564,
    x2: 19.9997,
    y2: 34.5564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_338",
    x1: 19.6433,
    y1: 26.5026,
    x2: 18.3661,
    y2: 35.0775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7662BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7662BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_338",
    x1: 15.763,
    y1: 25.1565,
    x2: 19.7369,
    y2: 18.2735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_338",
    x1: 24.2464,
    y1: 28.7618,
    x2: 28.1726,
    y2: 19.7731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_338",
    x1: 34.8188,
    y1: 23.2327,
    x2: 32.5358,
    y2: 32.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_715_338",
    x1: 28.7871,
    y1: 31.8434,
    x2: 30.9649,
    y2: 27.0757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_715_338",
    x1: 33.1949,
    y1: 42.1095,
    x2: 33.1949,
    y2: 21.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_715_338",
    x1: 27.2777,
    y1: 24.492,
    x2: 39.2687,
    y2: 34.8227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D3645",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48095513);
export default __webpack_public_path__ + "static/media/Group 48095513.1b037300e2db549fe9c40cbac1b64607.svg";
export { ForwardRef as ReactComponent };